<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection>
          <div class="text-right">
            <argon-button :to="{ name: 'Create Pengurangan' }" :isRouteLink="true"><font-awesome-icon icon="fa-solid fa-plus" /> Tambah Pengurangan</argon-button>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="12">
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <InputGroup class="w-100">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="getData()" type="text" class="form-control"
                      placeholder="Cari tingkat permasalahan...">
                  </InputGroup>

                  <FormGroup class="m-0 w-100">
                    <select @change="getData()" name="status" id="status" class="form-control" v-model="params.status">
                      <option value="">Semua Status</option>
                      <option value="active">Aktif</option>
                      <option value="inactive">Non Aktif</option>
                    </select>
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <ListView :thead="['Tingkat Permasalahan', 'Nilai', 'status', 'Aksi']">
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="4" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ item.tingkat_permasalahan ?? "" }}</td>
                <td>{{ item.nilai ?? "" }}</td>
                <td>
                  <argon-badge v-if="item.status == 'active'" color="success">Aktif</argon-badge>
                  <argon-badge v-if="item.status == 'inactive'" color="danger">Non Aktif</argon-badge>
                </td>
                <td class="align-top">
                  <ThreeDotsMenu>
                    <router-link :to="{ name: 'Update Pengurangan', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Edit</router-link>
                    <button @click.prevent="deleteData(item.id)"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                      data-original-title="Delete user">Hapus</button>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
            <div class="d-flex flex-row flex-wrap gap-2 justify-content-center align-items-center">
              <button type="button" @click="params.page = params.page - 1"
                class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-left" /></button>
              <p>{{ metaData?.current_page ?? "&infin;" }} / {{ metaData?.total_page ?? "&infin;" }}</p>
              <button type="button" @click="params.page = params.page + 1"
                class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-right" /></button>
            </div>
          </ListView>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import PenguranganApi from '@/repository/api/PenguranganApi';
import ArgonBadge from '@/components/ArgonBadge.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import FormGroup from '@/components/FormGroup.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import ListView from '@/components/ListView.vue';

export default {
  name: "tables",
  components: {
    ArgonButton,
    CardComponent,
    InputGroup,
    ArgonBadge,
    ThreeDotsMenu,
    FormGroup,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      params: {
        keyword: "",
        type: "",
        status: "",
        page: 1,
      },
      metaData: {},
    };
  },
  async mounted() {
    await this.getData();
  },
  watch: {
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          await this.getData();
        }
      },
      deep: false,
    },
  },
  methods: {
    async getData() {
      Object.keys(this.params).forEach(key => {
        if (this.params[key] === undefined) {
          delete this.params[key];
        }
      });
      clearTimeout(this.timer)
      if (this.params.keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (this.params.keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll();
        }, 1500)
      }
    },
    async getDataAll() {
      this.$store.state.loading = true;
      await PenguranganApi.getbyparam(this.params).then((response) => {
        this.data = response.data;
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = this.params.page - 1;
        }
        this.data = [];
      })
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await PenguranganApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
          });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
